import styles from '@/styles/productDetail/hotSearch.module.scss'
import Link from 'next/link'
import productApi from '@/service/modules/productApi'
import { useEffect, useState } from 'react'
import { message } from 'antd'

export default function HotSearch(props: any) {

  useEffect(() => {
    getHotSearchList()
  }, [])

  const [hotSearchList, setHotSearchList] = useState([])

  const getHotSearchList = async () => {
    try {
      let res = await productApi.getHotSearch({
        productID: props.productID
      })
      // 判断数据类型为数组并且有值才赋值
      if (
        res.data && 
        res.data.hotSearchKeywords && 
        Array.isArray(res.data.hotSearchKeywords)
      ) {
        setHotSearchList(res.data.hotSearchKeywords)
      }
    } catch (error: any) {
      console.error(error)
    }
  }
  return (
    <div className={styles['hotSearch']}>
      <div className={styles['title']}>Hot Search</div>
      <div className={styles['list']}>
        {
          hotSearchList.map((item: any, index: number) => (
            <div className={styles['item']} key={index}>
              <span className={styles['link']} onClick={() => { window.location.href = item.url }}>{item.keywords}</span>
              {/* <Link
                href={item.url}
                legacyBehavior
              >
                <a className={styles['link']} rel="noopener noreferrer">{item.keywords}</a>
              </Link> */}
            </div>
          ))
        }

      </div>
    </div>
  )
}